import { ApiError } from '@/api/errors';
import type { PayoutHold } from '@/api/tmm/types';

export function isPayoutOnHold(error: unknown): boolean {
  return error instanceof ApiError && String(error.code) === 'PAYOUT_ON_HOLD';
}

/** TMMAPI-0099: 409 `PAYOUT_NOT_PAYABLE` — the settlement was charged to the reseller's card. */
export function isPayoutNotPayable(error: unknown): boolean {
  return error instanceof ApiError && String(error.code) === 'PAYOUT_NOT_PAYABLE';
}

/**
 * TMMPDM-0044: the holds tmm-api refuses with 409 `PAYOUT_ON_HOLD` before it reads `override`
 * (`PayoutStatementService`, tmm-api `73f5b67`). Read off the server's hold code alone: Record
 * payout is disabled on these, and any other hold may be recorded. `HOLD_AFFILIATE_REVIEW`
 * (TMMAPI-0106) is refused the same way.
 */
const REFUSED_HOLDS: ReadonlySet<PayoutHold> = new Set<PayoutHold>([
  'HOLD_TAX_DOCS',
  'HOLD_RESELLER_UNPAID',
  'HOLD_AFFILIATE_REVIEW',
]);

export function isRefusedHold(hold: PayoutHold | undefined): hold is PayoutHold {
  return hold !== undefined && REFUSED_HOLDS.has(hold);
}

/** The hold a 409 `PAYOUT_ON_HOLD` names in its details, when it is one we know. */
export function refusedHoldOf(error: unknown): PayoutHold | undefined {
  if (!(error instanceof ApiError)) return undefined;
  const hold = error.details.backend?.['hold'];
  return typeof hold === 'string' && REFUSED_HOLDS.has(hold as PayoutHold)
    ? (hold as PayoutHold)
    : undefined;
}
